import React from "react";
import useHorizontalOverflow from "../useHorizontalOverflow";

export default function WorldInlineQuestion({
  number,
  children,
  showNumber = true,
}) {
  const scrollRef = React.useRef(null);
  const { hasOverflow, hasMoreToRight } = useHorizontalOverflow(scrollRef);

  return (
    <div style={styles.line}>
      {showNumber && <span style={styles.number}>{number}.</span>}
      <div style={styles.textWrap}>
        <div ref={scrollRef} style={styles.text} data-question-scroll-owner="true">
          {children}
        </div>

        {hasMoreToRight && (
          <div style={styles.rightOverflowFade} aria-hidden="true" />
        )}

        {hasOverflow && (
          <div style={styles.scrollHint} role="status">
            Scroll right to see the rest of this question →
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  line: {
    display: "flex",
    alignItems: "flex-start",
    gap: 8,
    width: "100%",
    maxWidth: "100%",
    minWidth: 0
  },
  number: {
    fontWeight: "bold",
    whiteSpace: "nowrap"
  },
  textWrap: {
    position: "relative",
    flex: 1,
    minWidth: 0,
    maxWidth: "100%"
  },
  text: {
    lineHeight: 1.6,
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    overflowX: "auto"
  },
  rightOverflowFade: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 31,
    width: 34,
    pointerEvents: "none",
    background:
      "linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,0.96))"
  },
  scrollHint: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    minHeight: 28,
    marginTop: 4,
    padding: "3px 8px",
    borderRadius: 4,
    backgroundColor: "#f3f4f6",
    color: "#444",
    fontSize: 13,
    fontWeight: 700,
    whiteSpace: "nowrap"
  }
};
